import { useGetMachineStatusQuery } from 'api';
import { MachineLineStatus, SiteTableType } from 'types/protein';
import { BusinessUnit } from 'types/dsi';

interface UseMachineStatusParams {
  plantId: string;
  type: SiteTableType;
  businessUnit?: BusinessUnit;
}

export const useMachineStatusInfo = ({
  plantId,
  type,
  businessUnit
}: UseMachineStatusParams): {
  isLoading?: boolean;
  isFetching?: boolean;
  error?: string;
  [key: string]: unknown;
  data?: MachineLineStatus[];
} => {
  const shouldSkip = type !== 'MACHINE' || !plantId;

  const { data, isLoading } = useGetMachineStatusQuery(
    { plantId, businessUnit },
    {
      skip: shouldSkip,
      pollingInterval: 30000
    }
  );

  return {
    isLoading,
    data
  };
};
